<template>
  <el-dialog
    title="详情信息"
    :visible.sync="localVisible"
    width="800px"
    @close="$emit('closeDialog')">

    <el-descriptions :column="1" border>
      <el-descriptions-item label="产品种类">{{ detailData.cropName }}</el-descriptions-item>
      <el-descriptions-item label="类型">{{ detailData.type }}</el-descriptions-item>
      <el-descriptions-item label="价格">{{ detailData.price }}</el-descriptions-item>
      <el-descriptions-item label="数量">{{ detailData.num }}{{ detailData.unit }}</el-descriptions-item>
      <el-descriptions-item label="交货地址">{{ detailData.address }}</el-descriptions-item>
      <el-descriptions-item label="产品说明">
        <pre class="description-pre">{{ detailData.memo }}</pre>
      </el-descriptions-item>
      <el-descriptions-item label="产品图片">
        <el-image
          v-for="(img, index) in previewList"
          :key="index"
          :src="img.url"
          :preview-src-list="previewList"
          class="image-thumb"
          fit="cover"
        />
      </el-descriptions-item>
    </el-descriptions>

    <span slot="footer">
      <el-button @click="localVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'DetailDialog',
  props: {
    visible: Boolean,
    detailData: Object
  },
  data() {
    return {
      baseUrl: window.globalUrl.HOME_API,
      localVisible: this.visible,
      previewList: []
    }
  },
  watch: {
    visible(val) {
      this.localVisible = val;
      if (val) {
        if (this.detailData.img && JSON.parse(this.detailData.img).length > 0) {
          this.previewList = JSON.parse(this.detailData.img).map(item => ({ ...item, url: this.baseUrl + 'admin/file/get?ossFilePath=' + item.url }))
        } else {
          this.previewList = []
        }
      } else {
        this.previewList = []
      }
    }
  },
  methods: {
    handleClose() {
      this.previewList = []
      this.localVisible = false
    }
  }
}
</script>

<style scoped>
.description-pre {
  white-space: pre-wrap;
  word-break: break-all;
}
.image-thumb {
  width: 100px;
  height: 100px;
  margin-right: 10px;
  border-radius: 4px;
}
</style>
